import React, { useState } from 'react';
//import '../style.css';
import '../style/base.css';
import '../style/navbar.css';
import '../style/pages.css';
import '../style/responsive.css';
import '../style/sidebar.css';

const Navbar = ({ setActiveSection }) => {
  const [activeLink, setActiveLink] = useState('about');

  const handleNavClick = (section) => {
    setActiveLink(section);
    setActiveSection(section);
  };

  return (
    <nav className="navbar">
      <ul className="navbar-list">
        {['about', 'resume', 'portfolio', 'Workflows', 'contact'].map((section) => (
          <li key={section} className="navbar-item">
            <button 
              className={`navbar-link ${activeLink === section ? 'active' : ''}`}
              onClick={() => handleNavClick(section)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
